import { apiGet, apiPost, registerLookup } from "@redriver/cinnamon";

const NAMESPACE = "CUSTOMERS/SIGNATORIES";

export const ClientAuthSignsLookups = {
  GetAuthSigns: "getClientAuthSignsLookup",
  GetPendingSigns: "getClientPendingSignsLookup",
};

const ActionTypes = {
  GetClientAuthorisedSignatories: `${NAMESPACE}/GET_CLIENT_AUTHORISED_SIGNATORIES`,
  GetClientArchivedSignatories: `${NAMESPACE}/GET_CLIENT_ARCHIVED_SIGNATORIES`,
  AddClientAuthorisedSignatory: `${NAMESPACE}/ADD_CLIENT_AUTHORISED_SIGNATORY`,
  GetAuthSigns: "LOOKUPS/GET_CLIENT_AUTH_SIGNS",
  GetPendingSigns: "LOOKUPS/GET_CLIENT_PENDING_AUTH_SIGNS",
};

export const getClientAuthorisedSignatories = (_, { clientId }) => {
  const cs = apiGet(
    ActionTypes.GetClientAuthorisedSignatories,
    `clients/${clientId}/authorised-signatories`,
    { pageNumber: 1 },
  );
  return cs;
};

export const getClientArchivedSignatories = (_, { clientId }) => {
  const cs = apiGet(
    ActionTypes.GetClientArchivedSignatories,
    `clients/${clientId}/archived-signatories`,
    { pageNumber: 1 },
  );
  return cs;
};

export const addClientAuthorisedSignatory = (data, { clientId }) =>
  apiPost(
    ActionTypes.AddClientAuthorisedSignatory,
    `clients/${clientId}/authorised-signatories`,
    data,
  );

registerLookup(
  ClientAuthSignsLookups.GetPendingSigns,
  ({ clientId }) =>
    apiGet(
      ActionTypes.GetAuthSigns,
      "lookups/clients/pending-authorised-signatories",
      {
        clientId,
      },
    ),
  {
    cache: false,
    transform: (data) =>
      Array.isArray(data)
        ? data.map((x) => ({
            ...x,
            value: x.id,
            text: `${x.name} - ${x.position} - ${x.email}`,
          }))
        : [],
  },
);

registerLookup(
  ClientAuthSignsLookups.GetAuthSigns,
  ({ clientId }) =>
    apiGet(ActionTypes.GetAuthSigns, "lookups/clients/authorised-signatories", {
      clientId,
    }),
  {
    cache: false,
    transform: (data) =>
      Array.isArray(data)
        ? data.map((x) => ({
            ...x,
            value: x.id,
            text: `${x.name} - ${x.position} - ${x.email}`,
          }))
        : [],
  },
);
